// Module
var code = "<template>\n  <button disabled.bind=\"disabled\" class=\"button\" class.bind=\"classes + ' ' + styleClasses\" click.delegate=\"onClick()\">\n    <slot></slot>\n  </button>\n</template>\n";
// Exports
export default code;